import { Button } from "@/components/ui/button";
import { Star, ExternalLink, MessageCircle } from "lucide-react";
import { getWhatsAppUrl, CLINIC_NAME } from "@/lib/constants";
import Breadcrumbs from "@/components/Breadcrumbs";
import CTABanner from "@/components/CTABanner";
import r01 from "@/assets/reviews/review-01.jpg.asset.json";
import r02 from "@/assets/reviews/review-02.jpg.asset.json";
import r03 from "@/assets/reviews/review-03.jpg.asset.json";
import r04 from "@/assets/reviews/review-04.jpg.asset.json";
import r05 from "@/assets/reviews/review-05.jpg.asset.json";
import r06 from "@/assets/reviews/review-06.jpg.asset.json";
import r07 from "@/assets/reviews/review-07.jpg.asset.json";
import r08 from "@/assets/reviews/review-08.jpg.asset.json";
import r09 from "@/assets/reviews/review-09.jpg.asset.json";
import r10 from "@/assets/reviews/review-10.jpg.asset.json";
import r11 from "@/assets/reviews/review-11.jpg.asset.json";
import r12 from "@/assets/reviews/review-12.jpg.asset.json";
import r13 from "@/assets/reviews/review-13.jpg.asset.json";
import r14 from "@/assets/reviews/review-14.jpg.asset.json";
import r15 from "@/assets/reviews/review-15.jpg.asset.json";
import r16 from "@/assets/reviews/review-16.jpg.asset.json";

const REVIEW_IMAGES = [r01, r02, r03, r04, r05, r06, r07, r08, r09, r10, r11, r12, r13, r14, r15, r16];

const Testimonials = () => {
  return (
    <div>
      <section className="bg-secondary py-12 md:py-16">
        <div className="container">
          <Breadcrumbs items={[{ label: "Testimonials" }]} />
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-secondary-foreground mb-3">
            Real Smile Transformations
          </h1>
          <p className="text-secondary-foreground/80 max-w-2xl">
            Before & after results from real patients at {CLINIC_NAME}. Every transformation tells a story of confidence renewed.
          </p>
          <div className="flex items-center gap-2 mt-4">
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map(i => <Star key={i} className="h-5 w-5 fill-primary text-primary" />)}
            </div>
            <span className="text-secondary-foreground/80 text-sm">4.9 rated on Google · 500+ reviews</span>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {REVIEW_IMAGES.map((img, i) => (
              <div key={i} className="overflow-hidden rounded-2xl border border-border bg-card shadow-sm">
                <img
                  src={img.url}
                  alt={`Patient smile transformation ${i + 1} at ${CLINIC_NAME}`}
                  loading="lazy"
                  className="w-full h-auto object-contain bg-muted"
                />
              </div>
            ))}
          </div>

          <p className="text-xs text-muted-foreground italic text-center mt-10">
            Results may vary. All photos shared with patient consent.
          </p>

          <div className="flex flex-wrap justify-center gap-3 mt-6">
            <Button asChild>
              <a href={getWhatsAppUrl("Hi, I'd like to discuss a smile transformation.")} target="_blank" rel="noopener noreferrer">
                <MessageCircle className="h-5 w-5 mr-2" /> Get Your Smile Reviewed
              </a>
            </Button>
            <Button asChild variant="outline">
              <a href="/write-review">
                <ExternalLink className="h-4 w-4 mr-2" /> Write a Review on Google
              </a>
            </Button>
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
};

export default Testimonials;
